export default "__VITE_ASSET__CD2vW7WM__"